import React from 'react'
import { Alert } from 'react-bootstrap'

import {
  BooleanRadioButtonField, yesNoDataSource, IField, validateFieldsEx,
} from '../../../../shared/fields'
import { ApplicationModel } from '../../../../models/ApplicationModel'
import EMDGAccordion from '../../../../shared/EMDGAccordion'
import { GRANT_GUIDELINES_URL } from '../..'

export interface Props {
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    visible: boolean
    preview?: boolean
}

export interface State {

}

export default class GoodsContainer extends React.Component<Props, State> implements IField {
  areGoodsMadeInAustralia: BooleanRadioButtonField
  goodsSatisfyNonAustralianCriteria: BooleanRadioButtonField
  doAustralianGoodsMeetRequirement: BooleanRadioButtonField
  areGoodsInappropriate: BooleanRadioButtonField

  constructor(props: Props) {
    super(props)

    this.state = {

    }
  }

  componentDidUpdate(prevProps: Props) {
    const { model, onChange, visible } = this.props

    if (visible && (model.areGoodsMadeInAustralia !== prevProps.model.areGoodsMadeInAustralia)) {
      onChange({ goodsSatisfyNonAustralianCriteria: null, doAustralianGoodsMeetRequirement: null, areGoodsInappropriate: null })
    }
    if (model.goodsSatisfyNonAustralianCriteria !== prevProps.model.goodsSatisfyNonAustralianCriteria) {
      onChange({ areGoodsInappropriate: null, doAustralianGoodsMeetRequirement: null })
    }
    if (model.doAustralianGoodsMeetRequirement !== prevProps.model.doAustralianGoodsMeetRequirement) {
      onChange({ areGoodsInappropriate: null, goodsSatisfyNonAustralianCriteria: null })
    }
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    const { model } = this.props
    if (model.goodsSatisfyNonAustralianCriteria === false || model.doAustralianGoodsMeetRequirement === false || model.areGoodsInappropriate) {
      callback && callback(false) // don't ever continue!
      return
    }

    validateFieldsEx(
      focus,
      callback,
      this.areGoodsMadeInAustralia,
      this.goodsSatisfyNonAustralianCriteria,
      this.doAustralianGoodsMeetRequirement,
      this.areGoodsInappropriate,
    )
  }

  render() {
    const {
      model, onChange, visible, preview,
    } = this.props
    return (
      visible && (
        <div style={{ marginTop: '30px' }}>
          { preview && <h4>Goods</h4>}
          <EMDGAccordion expanded header="Goods">
            <BooleanRadioButtonField
              ref={(r) => { this.areGoodsMadeInAustralia = r }}
              id="areGoodsMadeInAustralia"
              label="70. Are the goods made in Australia?"
              value={model.areGoodsMadeInAustralia}
              onChange={(areGoodsMadeInAustralia) => onChange({ areGoodsMadeInAustralia })}
              description={(
                <i>
                  For a good to be eligible, it must be of substantially Australian origin.
                </i>
              )}
              required={visible}
              dataSource={yesNoDataSource}
              preview={preview}
            />
            {model.areGoodsMadeInAustralia === true && (
            <BooleanRadioButtonField
              ref={(r) => { this.doAustralianGoodsMeetRequirement = r }}
              id="doAustralianGoodsMeetRequirement"
              label="70.a Do the goods meet at least one of the following requirements?"
              value={model.doAustralianGoodsMeetRequirement}
              onChange={(doAustralianGoodsMeetRequirement) => onChange({ doAustralianGoodsMeetRequirement })}
              description={(
                <ul>
                  <li style={{ marginTop: '0px' }}>Primary produce, or mainly made from primary produce (that is mined, harvested, raised or fished) within Australia</li>
                  <li>
                    Manufactured or assembled in Australia partly or wholly from imported materials or components that, in Australia, undergo or are part of a process or operation that:
                    <ul>
                      <li>results in the manufacture of a new product; or</li>
                      <li>substantially transforms the nature of the materials or components; or</li>
                      <li>is an important stage in the manufacture of a product to be produced outside Australia using those goods.</li>
                    </ul>
                  </li>
                </ul>
                    )}
              required={model.areGoodsMadeInAustralia}
              dataSource={yesNoDataSource}
              preview={preview}
            />
            )}
            {model.doAustralianGoodsMeetRequirement && (
            <Alert className="emdg-page-alerts">
              You have an eligible good. Proceed to Question 72.
            </Alert>
            )}
            {!model.doAustralianGoodsMeetRequirement && model.doAustralianGoodsMeetRequirement !== null && (
            <Alert className="emdg-page-alerts emdg-page-alerts--error">
              You are
              {' '}
              <b>not</b>
              {' '}
              eligible to apply for a grant as you do not have an eligible good.
            </Alert>
            )}
            { (!model.areGoodsMadeInAustralia && model.areGoodsMadeInAustralia !== null) && (
              <>
                <BooleanRadioButtonField
                  ref={(r) => { this.goodsSatisfyNonAustralianCriteria = r }}
                  id="goodsSatisfyNonAustralianCriteria"
                  label="71. Do the goods meet all the following requirements for goods made outside Australia?"
                  description={(
                    <ul>
                      <li style={{ marginTop: '0px' }}>
                        The assets used to make the goods ready for sale (other than assets used in
                        manufacture) are mainly or substantially based in Australia.
                      </li>
                      <li style={{ marginTop: '0px' }}>
                        The activities resulting in the goods being made ready for sale (other than manufacture)
                        are mainly or substantially carried on in Australia.
                      </li>
                      <li style={{ marginTop: '0px' }}>A significant proportion of the value of the goods is added in Australia.</li>
                      <li style={{ marginTop: '0px' }}>The making of the goods directly generates significant employment in Australia.</li>
                    </ul>
                                )}
                  value={model.goodsSatisfyNonAustralianCriteria}
                  onChange={(goodsSatisfyNonAustralianCriteria) => onChange({ goodsSatisfyNonAustralianCriteria })}
                  required={!model.areGoodsMadeInAustralia}
                  dataSource={yesNoDataSource}
                  preview={preview}
                />
                {model.goodsSatisfyNonAustralianCriteria === false && (
                <Alert className="emdg-page-alerts emdg-page-alerts--error">
                  You are
                  {' '}
                  <b>not</b>
                  {' '}
                  eligible to apply for a grant as you do not have an eligible good.
                </Alert>
                )}

                {model.goodsSatisfyNonAustralianCriteria && (
                <Alert className="emdg-page-alerts">
                  You are required to attach a Goods made outside Australia submission that addresses these qualifying conditions
                  (template available at
                  {' '}
                  <a target="_blank" href="https://www.austrade.gov.au/emdg" rel="noreferrer">www.austrade.gov.au/EMDG</a>
                  ) and proceed to Question 72.
                </Alert>
                )}
              </>
            )}

            {model.doAustralianGoodsMeetRequirement || model.goodsSatisfyNonAustralianCriteria ? (
              <BooleanRadioButtonField
                ref={(r) => { this.areGoodsInappropriate = r }}
                id="areGoodsInappropriate"
                label="72. Do the goods that you export include any one of the following? "
                value={model.areGoodsInappropriate}
                onChange={(areGoodsInappropriate) => onChange({ areGoodsInappropriate })}
                description={(
                  <ul>
                    <li>
                      The manufacturing or assembly process is partly or wholly from imported materials and components and:
                      <ul>
                        <li>is designed to circumvent rules relating to the origin or origins of the product; or</li>
                        <li>consists of only grading, packing or sorting the materials or components.</li>
                      </ul>
                    </li>
                    <li>The goods are pornographic in nature, including pornographic material in publications, films or computer games, or accessible on the internet.</li>
                    <li>The activities or products are unlawful.</li>
                  </ul>
)}
                required={visible && (model.doAustralianGoodsMeetRequirement || model.goodsSatisfyNonAustralianCriteria)}
                dataSource={yesNoDataSource}
                preview={preview}
              />
            ) : null}
            {model.areGoodsInappropriate && (
            <Alert className="emdg-page-alerts emdg-page-alerts--error">
              These goods are excluded. Unless you have another eligible product, you are not eligible to apply for a grant.
              If you have a combination of goods, you must exclude expenses related to marketing these excluded goods from your grant application.
            </Alert>
            )}
            {!model.areGoodsInappropriate && model.areGoodsInappropriate !== null && (
            <Alert className="emdg-page-alerts">
              You declare that you export goods that are not excluded as per Section 5.2.1.1 of the
              {' '}
              <a target="_blank" href={`${GRANT_GUIDELINES_URL}`} rel="noreferrer">
                Grant Guidelines
              </a>
              .
            </Alert>
            )}
          </EMDGAccordion>
        </div>
      )
    )
  }
}
